
<div class="header-toolbar">
  <h1 *ngIf="mode === 'view'">{{ record?.name }}</h1>
</div>

<form #form="ngForm" autocomplete="off" *ngIf="record">

  <!-- Toolbar -->
  <div class="main btn-toolbar">
    
    <a class="btn" [routerLink]="['organigramme']">
      <t-icon name="device_hub"></t-icon>
      <span class="text">Organigramme</span>
    </a>

  </div>
  <!-- /Toolbar -->

  <div class="grid" *ngIf="record">

    <div class="column">

      <div *ngIf="mode === 'view'" class="panel">
        <h2>Enregistrement</h2>

        <div class="form-group">
          <label for="name">Nom</label>
          <span id="name" class="value">{{ record.name }}</span>
        </div>

        <div class="form-group">
          <label for="is_root">Dossier</label>
          <span id="is_root" class="value">{{ record.is_root | yesno }}</span>
        </div>
      </div>
      
      <div *ngIf="mode === 'view'" class="panel">
        <h2>Autres</h2>

        <div class="form-group">
          <label for="id">Identifiant</label>
          <span id="id" class="value">{{ record.id }}</span>
        </div>

        <div class="form-group">
          <label for="created_at">Date d'ajout</label>
          <span id="created_at" class="value">{{ record.created_at | tzdate }}</span>
        </div>

        <div class="form-group">
          <label for="created_by">Ajoutée par</label>
          <span id="created_by" class="value">{{ record.created_by.fullname }}</span>
        </div>

        <div class="form-group">
          <label for="created_at">Date de modification</label>
          <span id="created_at" class="value">{{ record.updated_at | tzdate }}</span>
        </div>

        <div class="form-group">
          <label for="updated_by">Modifiée par</label>
          <span id="updated_by" class="value">{{ record.updated_by.fullname }}</span>
        </div>
      </div>
      
    </div>

    <div class="column">

      <table *ngIf="mode === 'edit' || mode === 'view'">
        <thead>
          <tr>
            <th>Dossier</th>
            <th>Lien</th>
            <th style="width: 50px;"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let link of record.links" (click)="showDossier(link)">
            <td name="Dossier">{{ link.dossier.name }}</td>
            <td name="Lien">{{ dossierModel.getTargetLabel(link.name) }}</td>
            <td style="width: 50px;" class="actions">
            <a class="action-btn">
              <t-icon name="arrow_forward"></t-icon>
            </a>
          </td>
          </tr>
        </tbody>
      </table>

    </div>

  </div>
</form>